import React from 'react';

import type { TextFieldProps } from '@mui/material/TextField/TextField';
import { Controller } from 'react-hook-form';

import QCategoryField from 'components/QuickenControls/CategoryField';
import type { FormInputProps } from './types';

const CategoryField = ({
  control,
  helperText,
  label,
  name,
  rules,
  ...other
}: FormInputProps & TextFieldProps & { filterFn?: (arg: any) => boolean }) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({ field: { onBlur, onChange, value }, fieldState: { error } }) => (
      <QCategoryField
        error={!!error}
        helperText={error?.message ? error.message : helperText}
        label={label}
        onBlur={onBlur}
        onChange={onChange}
        textFieldVariant='filled'
        value={value}
        editable
        {...other}
      />
    )}
  />
);

export default CategoryField;
